/* @jsx h */
import { defineComponent, h, ref, onMounted } from "vue";
import { TableStatus } from "@lemmonhq/types";
import { LemmonModal } from "@lemmonhq/uikit";

//import { AwesomeQR } from "awesome-qr";

export class AwesomeQR {
  constructor(props: any) {}
  async draw() {
    return "";
  }
}

export const TableQrModal = defineComponent({
  name: "TableQrModal",
  props: {
    table: {
      type: Object as () => TableStatus,
      required: true,
    },
    onClose: {
      type: Function,
      required: true,
    },
  },
  setup(props) {
    const qrCode = ref<string | null>(null);

    const generateQrCode = async () => {
      const buffer = await new AwesomeQR({
        text: "",
        size: 400,
        margin: 16,
        colorDark: "#000000",
        colorLight: "#ffffff",
        autoColor: false,
      }).draw();

      qrCode.value = buffer as string;
    };

    const downloadQrCode = () => {
      if (!qrCode.value) return;

      const link = document.createElement("a");
      link.download = `table-${props.table.table.name}-qr.png`;
      link.href = qrCode.value;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    onMounted(() => {
      generateQrCode();
    });

    return () => (
      <LemmonModal
        title={`QR Code for Table ${props.table.table.name}`}
        onClose={props.onClose}
      >
        <div class="p-8 flex flex-col items-center space-y-4">
          {qrCode.value ? (
            <>
              <img
                src={qrCode.value}
                alt={`QR Code for table ${props.table.table.name}`}
                class="w-64 h-64"
              />
              <p class="text-sm ">
                Scan this code to access table {props.table.table.name}
              </p>
              <button onClick={downloadQrCode} class="btn btn-primary">
                <span class="material-symbols-outlined mr-2">download</span>
                Download QR Code
              </button>
            </>
          ) : (
            <div class="loading loading-spinner loading-lg"></div>
          )}
        </div>
      </LemmonModal>
    );
  },
});
